<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
<v-card class="lighten-4 pl-3 pr-3" dark color="rgba(29,27,65,.6)">
  <v-row>
    <v-col cols="12" lg="4" class="pr-2">
      <v-card v-show="testedNumber > 0" dark flat class="pa-3 blue darken-4" v-bind:style="{ 'text-align': 'center', 'height': '100%' }">
        <div class="caption grey--text text--lighten-2">TESTED POSITIVE</div>
        <div class="headline mt-2">{{confirmedPerc + ' %'}}</div>      
        <div class="caption mt-2">{{getNumberDisplay(confirmedNumber) + ' of ' + getNumberDisplay(testedNumber)}}</div>
        <div class="caption mt-0">tests</div>
      </v-card>
      <v-card v-show="showIncrease" dark flat class="pa-3 blue darken-4" v-bind:style="{ 'text-align': 'center', 'height': '100%' }">
        <div class="caption text--lighten-2">LATEST INCREASE</div>
        <div class="headline mt-2">
        {{'+ ' + getNumberDisplay(increase)}}</div>      
        <div class="caption mt-2">confirmed cases</div>
      </v-card>
    </v-col>
    <v-col cols="12" lg="4" class="pr-1 pl-1">
      <v-card dark flat class="pa-3" color="rgb(35, 122, 113)" v-bind:style="{ 'text-align': 'center', 'height': '100%' }">
        <div class="caption grey--text text--lighten-2">CASE RECOVERY RATE</div>
        <div class="headline mt-2">{{recoveryPerc + ' %'}}</div>      
        <div class="caption mt-2">{{getNumberDisplay(recoveryNumber) + ' of ' + getNumberDisplay(confirmedNumber)}}</div>
        <div class="caption mt-0">cases</div>
      </v-card>
    </v-col>
    <v-col cols="12" lg="4" class="pl-2">
      <v-card dark flat class="pink darken-1 pa-3" v-bind:style="{ 'text-align': 'center', 'height': '100%' }">
        <div class="caption grey--text text--lighten-2">CASE FATALITY RATE</div>
        <div class="headline mt-2">{{fatalityPerc + ' %'}}</div>      
        <div class="caption mt-2">{{getNumberDisplay(fatalityNumber) + ' of ' + getNumberDisplay(confirmedNumber)}}</div>
        <div class="caption mt-0">cases</div>
      </v-card>
    </v-col>
  </v-row>
</v-card>
</template>

<script>

  export default {
    name: 'Stats',
    data: () => ({
      fatalityPerc: 0,
      recoveryPerc: 0,
      confirmedPerc: 0,
      fatalityNumber: 0,
      recoveryNumber: 0,
      confirmedNumber: 0,
      testedNumber: null,
      tested100kpax: 0,
      tested100kpaxdate: "",
      estimatedTests: 0,
      increase: 0,
      showIncrease: false
    }),
    methods: {
      loadCases(data, provinceDisplay) {
        this.fatalityPerc = 0
        this.recoveryPerc = 0
        this.confirmedPerc = 0
        this.fatalityNumber = 0
        this.recoveryNumber = 0
        this.confirmedNumber = 0
        this.testedNumber = 0
        this.tested100kpax = 0
        this.tested100kpaxdate = ""
        this.estimatedTests = 0
        this.increase = 0
        this.showIncrease = false

        //check no data
        if(data.length === 0) {
          return
        }

        //first get the distinct dates
        var dates = [];
        dates = Array.from(new Set(data.map(summ => summ.date))).map(date => {
          return date;
        });

        //find the date of the last entry
        var lastCaseDate = dates[dates.length - 1]

        //find the date of the prev entry
        var prevCaseDate = dates[dates.length - 2]

        //set the region filter
        var filterRegion = "National"
        //check if only one prov selected
        if(provinceDisplay && provinceDisplay !== "") {
          filterRegion = provinceDisplay
          this.showIncrease = true
        }

        //last and prev entries
        var matchLast = data.find(c => c.date === lastCaseDate && c.region === filterRegion)

        this.confirmedNumber = matchLast.confirmed*1
        this.recoveryNumber = matchLast.recovered*1
        this.fatalityNumber = matchLast.deceased*1
        this.testedNumber = matchLast.tests*1

        var matchPrev = data.find(c => c.date === prevCaseDate && c.region === filterRegion)
        var prevConfirmed = matchPrev.confirmed*1

        this.increase = this.confirmedNumber - prevConfirmed

        //percs
        var fperc = (this.fatalityNumber/this.confirmedNumber) * 100
        this.fatalityPerc = parseFloat(fperc.toFixed(0))

        var rperc = (this.recoveryNumber/this.confirmedNumber) * 100
        this.recoveryPerc = parseFloat(rperc.toFixed(0))

        var cperc = (this.confirmedNumber/this.testedNumber) * 100
        this.confirmedPerc = parseFloat(cperc.toFixed(0))

        //find the last 100k pax test count to estimate total tests
        //filter out only entries with prov tests per 100k pax
        var filteredData = data.filter(c => c.tests !== "" && c.region !== "National")

        //loop backwards
        for (var i = filteredData.length - 1; i >= 0; i--) {
          if(filteredData[i].region === filterRegion) {
            this.tested100kpax = filteredData[i].tests_100kpax*1
            this.estimatedTests = filteredData[i].tests*1
            this.tested100kpaxdate = filteredData[i].date
            break
          }
        }
      },
      getNumberDisplay(number) {
        if(!number) {
          return
        }
        return number.toLocaleString('en').replace(/\,/g, ' ')   
      }
    }
  }
</script>